"use client";

import { RobotBuild } from "./robot-build";
import type { PlayQuestionDTO } from "@/types/quiz";

/** 6 câu hỏi mẫu (đúng 6 bộ phận robot) cho bản chơi thử công khai "Chế tạo Robot". */
const DEMO_QUESTIONS: PlayQuestionDTO[] = [
  { id: "r1", prompt: "Bộ phận nào giúp robot quan sát xung quanh?", options: ["Bánh xe", "Mắt camera", "Cánh tay", "Loa"], correctIndex: 1 },
  { id: "r2", prompt: "Bộ phận nào chứa nguồn năng lượng và bộ điều khiển chính?", options: ["Thân robot", "Bàn tay", "Bàn chân", "Ăng-ten"], correctIndex: 0 },
  { id: "r3", prompt: "Cánh tay robot thường dùng để làm gì?", options: ["Phát sáng", "Nghe âm thanh", "Cầm và di chuyển đồ vật", "Sạc pin"], correctIndex: 2 },
  { id: "r4", prompt: "Khớp nối ở tay giúp robot làm gì?", options: ["Co và duỗi tay", "Nhìn xa hơn", "Nói to hơn", "Đổi màu"], correctIndex: 0 },
  { id: "r5", prompt: "Chân robot có nhiệm vụ chính là gì?", options: ["Ghi hình", "Phát nhạc", "Giữ thăng bằng và di chuyển", "Suy nghĩ"], correctIndex: 2 },
  { id: "r6", prompt: "Đế bàn chân rộng giúp robot điều gì?", options: ["Đứng vững hơn", "Nhìn rõ hơn", "Nghe tốt hơn", "Nói nhanh hơn"], correctIndex: 0 },
];

/** Bản chơi thử công khai (không đăng nhập, không gọi API) cho "Chế tạo Robot". */
export function RobotDemo() {
  return <RobotBuild questions={DEMO_QUESTIONS} onFinish={() => {}} />;
}
